var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{staticClass:"k-bullet-info",attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('a',_vm._g({staticStyle:{"text-decoration":"none"},attrs:{"target":"_blank","href":_vm.href}},on),[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon))])],1)]}}])},[_c('span',[_vm._v("Clique para saber mais.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }